<template>
  <a :id="buttonID" href="javascript:void(0)" class="btn" :title="hoverTitle" :class="cssClass" @click="onClick($event)">
    <span v-show="isBusy">
      <img src="../assets/tail-spin-white.svg" width="22" alt="">
    </span>
    {{ title }}
  </a>
</template>
<script>
export default {
  props: {
    isBusy: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    hoverTitle: {
      type: String,
      default: ''
    },
    btnClass: {
      type: [String, Object, Array],
      default: 'btn-primary'
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.id = this._uid;
  },
  methods: {
    onClick(ev) {
      if (!this.isBusy && this.enabled) {
        if(ev && ev.target && ev.target.blur) {
          ev.target.blur();
        } 
        this.$emit('click', ev);
      }
    }
  },
  computed: {
    buttonID () {
      return 'btn' + this._uid;
    },
    svgSupport () {
      return (document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#AnimationEventsAttribute', '1.0'));
    },
    cssClass () {
      const self = this;
      return [
        { 'disabled': this.isBusy || this.enabled === false },
        { 'loading': this.isBusy },
        self.btnClass
      ];
    }
  },
  watch: {
    message: function () {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }
};
</script>

<style lang="scss" scoped>
.btn.btn-primary {
  text-decoration: none;
    position: relative;
    &.loading {
        padding-left: 36px;
        span {
            position: absolute;
            left: 6px;
            top: 4px;
        }
    }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
